<div class="container">
    <div class="innerPage text-center">

        <h1 class="tac">404</h1>
        <h1 class="tac">Page Not Found</h1>

        <div class="tac">
            <a href="/">
                Go to Home Page
            </a>
        </div>
    </div>
</div>